// Pure file-type detection shared by the document viewer.
const matches = (ct, name, ctParts, nameRe) =>
  ctParts.some((p) => ct.includes(p)) || nameRe.test(name);

export function getFileKind(file) {
  const ct = (file?.content_type || "").toLowerCase();
  const name = (file?.filename || "").toLowerCase();
  const isPdf = matches(ct, name, ["pdf"], /\.pdf$/);
  const isImage = ct.startsWith("image/") || /\.(png|jpe?g|webp|gif|svg)$/.test(name);
  const isHtml = matches(ct, name, ["html"], /\.html?$/);
  const isDocx = matches(ct, name, ["wordprocessingml"], /\.docx$/);
  const isXlsx = matches(ct, name, ["spreadsheetml", "ms-excel", "excel"], /\.(xlsx|xls|csv)$/);
  const isPptx = matches(ct, name, ["presentation", "powerpoint"], /\.(pptx|ppt)$/);
  const isLegacyDoc = ct === "application/msword" || name.endsWith(".doc");
  return {
    isPdf, isImage, isHtml, isDocx, isXlsx,
    isUnsupportedOffice: isPptx || isLegacyDoc,
    canPrint: isPdf || isImage || isHtml,
  };
}
